<template>
  <ErrorPage type="403" :showBtn="false" @error-click="handleLogout" />
</template>

<script>
import ErrorPage from './Error.vue'
import keycloak from '@/utils/keycloak.js'
import { Message } from 'element-ui';

export default {
  name: 'Error403',
  components: {
    ErrorPage
  },
  mounted() {
    Message.error('用户不存在，请联系管理员');
  },
  methods: {
    handleLogout: function() {
      try {
        keycloak.logout()
      } catch (error) {
        console.error(error)
      } finally {
        // localStorage.removeItem('token')
        // localStorage.removeItem('isKeycloakLogin')
        localStorage.clear();
        this.$router.push('/login')
      }
    }
  }
}
</script>
